@if (content) {
<!-- title -->
<h3 class="h2"
    *iCms="'title' of content"></h3>
<!-- tabs -->
@if (content.tabs.length > 1) {
<div class="m-t-5 pos-relative inline-flex">
    @for (tab of content.tabs; track $index; let isLast = $last) {
    <button class="_tab-title pos-absolute top-50"
            [ngClass]="[isLast? 'left-3' : 'right-3', selection.tabId === tab.id ? 'col-1' : 'col-12']"
            (click)="changeActiveTab(tab.id)">{{tab.title}}</button>
    }
    <div class="_separator"></div>
</div>
}
<!-- carousel -->
@for ( tab of content.tabs; track $index) {
<div class="m-t-10 _carousel"
     [class._square]="squareVariant"
     [class._centerSwiper]="!isLoop(tab.options.length)"
     [class._hidden]="selection.tabId !== tab.id"
     [id]="tab.id">
    <carousel [slidesPerView]="'auto'"
              [freeMode]="true"
              [centeredSlides]="isLoop(tab.options.length)"
              [pagination]="{clickable: true}"
              [loop]="isLoop(tab.options.length)"
              [initialSlide]="getIndexOfSelection(tab.options)"
              (afterInit)="onAfterInit($event, tab.id)"
              [style.--pc-slides-ceil]="pcSlidesCeil"
              [style.--pc-slides]="pcSlides"
              [style.--pc-gutter]="pcGutter">
        @for (element of tab.options; track $index; let index = $index) {
        <ng-template swiperSlide>
            <div [class._active]="isActive(element.name, tab.id)"
                 class="_element cursor-pointer"
                 (click)="selectOption(element.name)">
                <div [ngClass]="squareVariant ? 'ratio-1-1' : 'ratio-2-3'"
                     [style.margin.px]="2">
                    <img class="rf _image"
                         [ngClass]="{'p-a-5 p-a-3-s p-a-3-m': squareVariant}"
                         [image]="element.image">
                </div>
                <p class="m-t p-b-3 p1 center"
                   *iCms="'name' of element"></p>
            </div>
        </ng-template>
        }
    </carousel>
</div>
}
}
